module.exports = __webpack_public_path__ + "static/media/threatcop-banner-jan.550e9847.png";